#import "./imageRevertPayload.gql"

mutation RevertGeneratedImage($input: RevertGeneratedImageInput!) {
  revertGeneratedImage(input: $input) {
    ... on GeneratedImage {
      ...ImageRevertPayload
      modelName
      topicId
    }
    __typename
  }
}
